export const formatSeconds = (seconds?: number | null) => {
  const minutes = Math.floor((seconds || 0) / 60);
  const remainingSeconds = (seconds || 0) % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
